// extracted by mini-css-extract-plugin
module.exports =  {"switch":"gLh0BaE","text":"vluDqBO","toggle":"uvOzdAC","size-small":"VVPyNtD","sizeSmall":"VVPyNtD","disabled":"kCpJqvq"};